import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('AppTabs').create(({ theme }) => ({
  root: {
    display: 'flex',
    gap: '8px',
    width: '100%',
  },

  tab: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 12px',
    gap: '8px',
    borderRadius: '8px',
    flex: 1,
    minWidth: 0,
    cursor: 'pointer',
    background: theme.colors.button.secondary.background,

    '&[data-isactive="true"]': {
      background: theme.colors.button.primary.background,
    },
    span: {
      color: 'white',
      fontSize: '13px',
      fontWeight: 460,
    },
  },
}))
